var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"justify-center"},[_c('span',{staticClass:"font-weight-semibold text-h5 "},[_vm._v("Dashboard of Assistant HCRP Manager")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }